import {GET_ALL_MESSAGES, SEND_MESSAGE, SET_ARRIVAL_MESSAGE} from '../actions/typesAction';

const initialState = {
    messages: [],
};

export default function messageReducer(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case GET_ALL_MESSAGES:
            return {
                ...state,
                messages: payload,
            };
        case SET_ARRIVAL_MESSAGE:
        case SEND_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, payload],
            };
        default:
            return state;
    }
}
